import { API_URL } from '../../../../utils/config';

export const GET_LEADS_URL = `${API_URL}/users/leads/1`;
export const EDIT_LEAD_URL = `${API_URL}/users`;
export const SEARCH_LEAD_URL = `${API_URL}/users/searchuser`;
